<template>
  <UIModal
    class="ModalDeleteGpt"
    size="lg"
    @close="emit('close')"
    @enter="emit('close')"
  >
    <template #title>
      <slot name="title">Delete custom GPT</slot>
    </template>

    <template #content>
      <slot name="content">
        Are you sure you want to permanently delete '{{ gpt.name }}'? This
        action cannot be undone and all chat history with this GPT will be
        permanently removed for you and other users that have access.

        <UIInputCheckboxBase
          v-model="isConfirmed"
          class="ModalDeleteGpt__checkbox"
          name="isConfirmed"
          label="I acknowledge and confirm deletion of this GPT"
        />
      </slot>
    </template>

    <template #actions>
      <slot name="actions">
        <UIButton theme="secondary" @click.prevent="emit('close')">
          Cancel
        </UIButton>
        <UIButton
          :isLoading="isLoading"
          theme="error"
          :isDisabled="!isConfirmed"
          @click.prevent="emit('confirm')"
        >
          Delete
        </UIButton>
      </slot>
    </template>
  </UIModal>
</template>

<script lang="ts" setup>
import { ref, useAttrs, watch } from 'vue'

import { UIButton, UIInputCheckboxBase, UIModal } from '@foundever/ui-lib'

import type { IGptListItem } from '@/apiClient/types/gpt'

const emit = defineEmits(['close', 'confirm'])
withDefaults(
  defineProps<{
    isLoading?: boolean
    gpt: IGptListItem
  }>(),
  {
    isLoading: false,
  },
)

const isConfirmed = ref(false)

const attrs = useAttrs()

watch(
  () => attrs.isOpen,
  () => {
    isConfirmed.value = false
  },
  { immediate: true },
)
</script>

<style lang="scss">
.ModalDeleteGpt.UIModalContainer {
  --modal-size: 31.625rem;

  .ModalDeleteGpt__checkbox {
    margin-top: 0.625rem;
    margin-bottom: 0.125rem;
  }
}
</style>
